<mat-form-field class="full-width">
  <mat-select [(ngModel)]="ITEM.value" class="full-width" [disabled]="disabled">
    <mat-option *ngFor="let taskgroup of taskgroups" [value]="taskgroup.id">
      {{ taskgroup.name }}
    </mat-option>
  </mat-select>
</mat-form-field>
